export default "__VITE_ASSET__adf03eb0__"